import { PromoCard, type PromoAnalytics } from 'components/promos/promo-card';
import { type SanityPromo, type SanityPromoLike } from '@metmuseum/types';
import styles from 'components/promos/promos.module.scss';
import {
	getContextAttributes,
	type AnalyticsContext,
} from 'lib/analytics/analyticsAttributes';

const Promos = ({ promos, analytics, analyticsContext }: IProps) => {
	return (
		<div
			className={styles.promoContainer}
			{...getContextAttributes(analyticsContext)}
		>
			{promos.map((promo) => {
				return (
					<PromoCard
						key={promo._id || promo._key}
						promo={promo}
						analytics={analytics}
					/>
				);
			})}
		</div>
	);
};

export interface IProps {
	promos: SanityPromo[] | SanityPromoLike[];
	analytics?: PromoAnalytics;
	analyticsContext?: AnalyticsContext;
}

export default Promos;
